import { render, staticRenderFns } from "./FormCreateButton.vue?vue&type=template&id=5c4ffedf&"
import script from "./FormCreateButton.vue?vue&type=script&lang=js&"
export * from "./FormCreateButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports